import { ClienteEditOut, ClienteListOut, ClienteProveedorEditOut, CotizadorComboItem, CotizadorEditIn, CotizadorEditOut, CotizadorListOut } from "../../../../model/clientes";
import { ComboItem } from "../../../../model/common/ComboItem";
import { Response } from '../../../../model';
import ServiceBase from "../../../servicebase";
import { ControllerEntityService } from "./ControllerEntityService";

export class ClientesService extends ServiceBase {
  private controller: string = 'clientes';

  //  Cliente = () => new ControllerEntityService<ClienteEditOut, ClienteEditOut, ClienteListOut, ComboItem, { codigo?: string, nombre?: string }, {}>(this.urlAPI, this.controller, "Cliente");

  Cliente = () => new ClienteService(this.urlAPI, this.controller);
  
  Cotizador = () => new ControllerEntityService<CotizadorEditOut, CotizadorEditIn, CotizadorListOut, CotizadorComboItem, { codigo?: string, nombre?: string, landingName?: string, clienteNombre?: string }, {}>(this.urlAPI, this.controller, "Cotizador");
}

export class ClienteService extends ControllerEntityService<ClienteEditOut, ClienteEditOut, ClienteListOut, ComboItem, { id?: number, nombre?:string, cuit?: string, codigo?:string, padreNombre?: string; asesor?:string, idsistemaexterno?: string }, { nivel?: number }> {
  constructor(urlApi: string, controller: string) {
    super(urlApi, controller, "Cliente");
  }
  
  vendedores = (data: { idCliente?: number, activos?: boolean, includeTodos?: boolean, includeNinguno?: boolean, includeId?: number }) => 
    this.GetFetch<Response<ComboItem[]>>(`${this._controller}/${this._entity}/vendedores`, data);
  
  proveedor = (data: { idCliente?: number, idProveedor?: number }) => 
    this.GetFetch<Response<ClienteProveedorEditOut>>(`${this._controller}/${this._entity}/proveedor`, data);
  
}
